import gql from 'graphql-tag';

const CLUB_MEMBER_DOCUMENT_DELETE= gql`
mutation clubMemberDocumentDelete($id: ID!) { 
  clubMemberDocumentDelete(id: $id)
}
`;

export default CLUB_MEMBER_DOCUMENT_DELETE;